var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-2", class: ["col-" + _vm.colSize] }, [
    _c(
      "div",
      { staticClass: "form-page" },
      _vm._l(_vm.optionsList, function (option) {
        return _c(
          "div",
          {
            key: option.id,
            staticClass: "form-group-material material-input-slot-wrapper row",
          },
          [
            _c(
              "div",
              { staticClass: "col-6 d-inline-flex align-items-center" },
              [
                _c("span", { staticClass: "col-5" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "col-6",
                  attrs: { id: option.id, type: "text", disabled: true },
                  domProps: { value: option.clientName },
                }),
              ]
            ),
            _vm._v(" "),
            _vm.additionalElement
              ? _c(
                  "div",
                  { staticClass: "col-6 d-inline-flex align-items-center" },
                  [
                    _c("span", { staticClass: "col-5" }, [
                      _vm._v(_vm._s(_vm.additionalElementComponents.label)),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "col-6",
                      attrs: {
                        id: "additionalComponent-" + option.id,
                        type: "text",
                        disabled: _vm.disabled,
                      },
                      domProps: {
                        value: _vm.additionalElementComponents.value,
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }